import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { applySwUpdate, onSwUpdate } from "./registerSW";
import { getLang } from "../lib/i18n";

export function UpdateToast() {
  const [ready, setReady] = useState(false);
  useEffect(() => onSwUpdate(() => setReady(true)), []);
  if (!ready) return null;
  return (
    <div className="fixed left-1/2 -translate-x-1/2 z-[80] bottom-[calc(var(--pm-nav-h)+var(--sab)+12px)] lg:bottom-6" data-testid="sw-update-toast">
      <button
        type="button"
        onClick={applySwUpdate}
        className="flex items-center gap-2 pl-4 pr-5 h-12 rounded-full bg-[#0A0F0C] text-white text-sm font-semibold shadow-[0_12px_40px_-10px_rgba(0,0,0,.6)] ring-1 ring-white/10 active:scale-[.98] transition-transform"
        data-testid="sw-update-reload"
      >
        <RefreshCw size={15} className="text-emerald-400" /> {getLang() === "en" ? "New version available — refresh" : "Nieuwe versie beschikbaar — vernieuwen"}
      </button>
    </div>
  );
}
